import XEUtils from "xe-utils";


/**
 * 格式化金额，并添加$前缀
 * @param cellValue
 * @param prefix
 * @returns {string|string}
 */
function formatMoney({cellValue}, prefix = "￥") {
	return cellValue || cellValue === 0 ? `${prefix}${XEUtils.commafy(XEUtils.toNumber(cellValue), {digits: 2})}` : ''
}

/**
 * 格式化为长日期格式
 * @param cellValue
 * @returns {*}
 */
function formatLongDate({cellValue}) {
	return XEUtils.toDateString(cellValue, 'yyyy-MM-dd HH:ss:mm')
}

/**
 * 格式化为短日期格式
 * @param cellValue
 * @returns {*}
 */
function formatShortDate({cellValue}) {
	return XEUtils.toDateString(cellValue, 'yyyy-MM-dd')
}


const RE_EMAIL = /^\s*[\w.-]+@([\w-]+\.)+(\w+)\s*$/

/**
 * 格式化链接，如果参数是邮箱地址，则添加mailto协议
 * @param cellValue
 * @returns {string}
 */
function formatLink({cellValue}) {
	let protocol = RE_EMAIL.test(cellValue) ? "mailto:" : "";
	return `<a href="${protocol}${cellValue}" target="_blank">${cellValue}</a>`
}

const SEX_MAP = {
	"1": "男",
	"M": "男",
	"MALE": "男",
	"0": "女",
	"F": "女",
	"FEMALE": "女",
	"男": "男",
	"女": "女"
};

/**
 * 格式化性别
 * @param cellValue
 * @returns {*}
 */
function formatSex({cellValue}) {
	let s = SEX_MAP[String(cellValue).toUpperCase()];
	return s || "-";
}

function formatDate({cellValue}) {
	return cellValue==='2040-01-09 17:13:14' ? '永久' : cellValue.split(' ')[0]
}

/**
 * 如果值为true，则显示"是"
 * @param cellValue
 * @returns {string}
 */
function formatYes({cellValue}) {
	return formatYesNo({cellValue}) === "是" ? "是" : "";
}

const YES_NO_MAP = {
	"1": "是",
	"YES": "是",
	"Y": "是",
	"TRUE": "是",
	"0": "否",
	"NO": "否",
	"N": "否",
	"FALSE": "否"
};

function formatYesNo({cellValue}) {
	let s = YES_NO_MAP[String(cellValue).toUpperCase()];
	return s || "-";
}

function formatLong({cellValue}) {
	let s = parseInt(cellValue);
	return s || 0;
}

function formatStringYesNo({cellValue}) {
	return cellValue ? '是' : '否';
}

const IS_OVERDUE_MAP = {
	"1": "超时",
	"0": "未超时",
};

function formatIsOverdue({cellValue}) {
	let s = IS_OVERDUE_MAP[String(cellValue).toUpperCase()];
	return s || "-";
}

let formatter = {
	formatLong,
	formatMoney,
	formatLongDate,
	formatShortDate,
	formatSex,
	formatLink,
	formatYes,
	formatYesNo,
	formatStringYesNo,
	formatDate,
	formatIsOverdue
}

export {
	formatter
}